import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgCornerArrowIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <path
      fill="currentColor"
      d="M37.738 22.4H24v-3.2h13.737a3.2 3.2 0 0 1 2.263.937L43.863 24c.6.6.937 1.414.937 2.263V40h-3.2V26.263l-.8-.8L21.932 44.33l-2.263-2.263L38.538 23.2z"
    />
  </svg>
)
export default SvgCornerArrowIcon
